"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartAccordions = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackCartAccordions(click_text, click_element, eventName) {
    const eventData = {
        eventName,
        feature_category: enums_1.GA4FeatureCategory.Cart,
        click_element,
        click_text,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: eventName === enums_1.GA4EventName.OpenAccordion
            ? enums_1.ClickEventType.OPEN_ACCORDION
            : enums_1.ClickEventType.CLOSE_ACCORDION,
        eventLabel: click_text,
        eventData,
    });
}
exports.trackCartAccordions = trackCartAccordions;
//# sourceMappingURL=trackCartAccordions.js.map